<template>
    <section>
    <v-container style="margin-top:80px; background-color:rgb(248, 248, 248)" class="pa-3 px-5">
            <div  class="font-weight-bold display-2 mb-2 text-center text-sm-h4 text-h6 mb-3" style="color:rgb(35, 0, 100)">Privacy Policy</div>
            <p>At App Genesis portals / websites / applications of / under the names and brands of App Genesis.in websites and its mobile apps together, accessible from http://appgenesis.in/, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by App Genesis and how we use it.</p>
            <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>
            <p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in App Genesis This policy is not applicable to any information collected offline or via channels other than this website.</p>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 ">Consent</div>
            <p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 ">Information We Collect</div>
            <p>The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.</p>
            <p>If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.</p>
            <p>When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number. </p>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 ">How we use your information</div>
            <p>We use the information we collect in various ways, including to:</p>
                • Provide, operate, and maintain our website </br>
                • Improve, personalize, and expand our website </br>
                • Understand and analyze how you use our website </br>
                • Develop new products, services, features, and functionality </br>
                • Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</br>
                • Send you emails </br>
                • Find and prevent fraud </br>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 mt-2">Log Files</div>
            <p>App Genesis follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.</p>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 ">Google DoubleClick DART Cookie</div>
            <p>Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads to our site visitors based upon their visit to www.website.com and other sites on the internet. However, visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy Policy at the following URL - https://policies.google.com/technologies/ads</p>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 ">Advertising Partners Privacy Policies</div>
            <p>You may consult this list to find the Privacy Policy for each of the advertising partners of App Genesis.</p>
            <p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on App Genesis, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p>
            <p>Note that App Genesis has no access to or control over these cookies that are used by third-party advertisers.</p>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 ">Third Party Privacy Policies</div>
            <p>App Genesis'ss Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.</p>
            <p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.</p>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 ">CCPA Privacy Rights (Do Not Sell My Personal Information)</div>
            <p>Under the CCPA, among other rights, California consumers have the right to:</p>
            <p>Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.</p>
            <p>Request that a business delete any personal data about the consumer that a business has collected.</p>
            <p>Request that a business that sells a consumer's personal data, not sell the consumer's personal data.</p>
            <p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 ">GDPR Data Protection Rights</div>
            <p>We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>
                • The right to access - You have the right to request copies of your personal data. We may charge you a small fee for this service.</br>
                • The right to rectification - You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</br>
                • The right to erasure - You have the right to request that we erase your personal data, under certain conditions.</br>
                • The right to restrict processing - You have the right to request that we restrict the processing of your personal data, under certain conditions.</br>
                • The right to object to processing - You have the right to object to our processing of your personal data, under certain conditions.</br>
                • The right to data portability - You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</br>
                • If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</br>
            <div  class="font-weight-bold display-2 mb-2  text-sm-h5 text-h6 mt-2">Children's Information</div>
            <p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>
            <p>App Genesis does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>

    </v-container>
</section>
  </template>
  
 
  
  <script>
  import navigation from "../components/Navigation";
  import foote from "../components/Footer";
  import home from "../components/HomeSection";
  import about from "../components/AboutSection";
  // import download from "../components/DownloadSection";
  import client from "../components/Client";
  import contact from "../components/ContactSection";
  import internshipTechno from "../components/InternshipTechnology.vue";
  import serveSection from "../components/ServeSection.vue";
  import ServeSection from '../components/ServeSection.vue';
import Opening from '../components/opening.vue';
import Achievements  from "../components/Achievements.vue";
  export default {
    name: "privacy",
  
    components: {
      navigation,
      foote,
      home,
      about,
      serveSection,
      // download,
      client,
      contact,
      internshipTechno,
      Opening,
      ServeSection,
      Achievements
  },
  
    data: () => ({
      fab: null,
      color: "",
      flat: null,
    }),
  
    created() {
      const top = window.pageYOffset || 0;
      if (top <= 60) {
        this.color = "transparent";
        this.flat = true;
      }
    },
  
    watch: {
      fab(value) {
        if (value) {
          this.color = "secondary";
          this.flat = false;
        } else {
          this.color = "transparent";
          this.flat = true;
        }
      },
    },
  
    methods: {
      onScroll(e) {
        if (typeof window === "undefined") return;
        const top = window.pageYOffset || e.target.scrollTop || 0;
        this.fab = top > 60;
      },
      gottoWhatsapp(){
  
      },
      toTop() {
        this.$vuetify.goTo(0);
      },
    },
  };
  </script>
  <style scoped>
  .v-main {
    background-image: url("~@/assets/img/bgMain.png");
    background-attachment: fixed;
    background-position: center;
    background-size: cover;
  }
  .whatsappIcon{
    position: fixed;
    bottom:40vh;
    right:0
  }
  .phoneIcon{
    position: fixed;
    bottom:35vh;
    right:0
  }
  </style>